function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.26,
    height: 9.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 4.54
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.08,
    width: 24.26,
    height: 19.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.48875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 19.035
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.99,
    width: 24.26,
    height: 24.14,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.828
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 41.06
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.12,
    width: 24.26,
    height: 27.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 66.77499999999999
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.43,
    width: 24.26,
    height: 32.05,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.695555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 96.45500000000001
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.48,
    width: 24.26,
    height: 38.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.043333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 131.82
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.15,
    width: 24.26,
    height: 40.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4657142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 171.615
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.08,
    width: 24.26,
    height: 41.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4657142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 212.94
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 233.81,
    width: 24.26,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 256.65
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 279.48,
    width: 24.26,
    height: 46.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 302.68
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 325.88,
    width: 24.26,
    height: 50.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 350.885
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 375.89,
    width: 24.26,
    height: 50.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 401.09999999999997
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 426.31,
    width: 24.26,
    height: 51.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 451.815
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 477.32,
    width: 24.26,
    height: 53.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.043333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 504.115
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 530.91,
    width: 24.26,
    height: 54.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 558.35
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 585.78,
    width: 24.26,
    height: 56.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 613.875
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 641.98,
    width: 24.26,
    height: 58.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.13,
    y: 670.99
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 0,
    width: 34.91,
    height: 41.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8183333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.715,
    y: 20.955
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.18,
    y: 0,
    width: 35.41,
    height: 41.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5409999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.88499999999999,
    y: 20.955
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.59,
    y: 0,
    width: 37.56,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.260000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.37,
    y: 20.955
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.15,
    y: 0,
    width: 37.89,
    height: 41.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.412857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.095,
    y: 20.955
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.04,
    y: 0,
    width: 39.09,
    height: 41.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.515000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.58499999999998,
    y: 20.955
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.13,
    y: 0,
    width: 39.74,
    height: 41.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229,
    y: 20.955
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.88,
    y: 0,
    width: 39.85,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.692857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.805,
    y: 20.955
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.73,
    y: 0,
    width: 39.9,
    height: 41.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.68,
    y: 20.955
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.63,
    y: 0,
    width: 41.66,
    height: 41.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.46,
    y: 20.955
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.29,
    y: 0,
    width: 41.88,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.23,
    y: 20.955
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.17,
    y: 0,
    width: 43.48,
    height: 41.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.191
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.91,
    y: 20.955
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 455.65,
    y: 0,
    width: 43.57,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.23875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.435,
    y: 20.955
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.22,
    y: 0,
    width: 47.65,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.23875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.0450000000001,
    y: 20.955
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.87,
    y: 0,
    width: 47.68,
    height: 41.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.382
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.71,
    y: 20.955
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.55,
    y: 0,
    width: 51.82,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.987142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.4599999999999,
    y: 20.955
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.36,
    y: 0,
    width: 53.64,
    height: 41.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8099999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.1800000000001,
    y: 20.955
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 41.91,
    width: 57.5,
    height: 41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.833333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 62.41
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 82.9,
    width: 57.5,
    height: 41.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.617777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 103.68
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 124.47,
    width: 57.5,
    height: 46.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.704999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 147.585
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 170.7,
    width: 57.5,
    height: 47.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.966666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 194.5
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 218.31,
    width: 57.5,
    height: 48.55,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 242.585
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 266.86,
    width: 57.5,
    height: 49.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.090000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 291.675
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 316.49,
    width: 57.5,
    height: 57.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 345.31
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 374.13,
    width: 57.5,
    height: 73.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 410.84
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 447.55,
    width: 57.5,
    height: 75.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 485.48
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 523.4,
    width: 57.5,
    height: 86.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 566.49
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.26,
    y: 609.59,
    width: 57.5,
    height: 90.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.2272727272727275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.010000000000005,
    y: 654.7950000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.76,
    y: 41.91,
    width: 64.8,
    height: 89.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.799999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.16,
    y: 86.54499999999999
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.56,
    y: 41.91,
    width: 66.37,
    height: 89.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.29625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.745,
    y: 86.54499999999999
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.94,
    y: 41.91,
    width: 67.36,
    height: 89.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.62,
    y: 86.54499999999999
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.29,
    y: 41.91,
    width: 71.06,
    height: 89.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.151428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.82000000000005,
    y: 86.54499999999999
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.36,
    y: 41.91,
    width: 72.23,
    height: 89.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.038333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.475,
    y: 86.54499999999999
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.59,
    y: 41.91,
    width: 79.88,
    height: 89.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.985
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.53,
    y: 86.54499999999999
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.47,
    y: 41.91,
    width: 83.86,
    height: 89.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.976666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.4,
    y: 86.54499999999999
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.34,
    y: 41.91,
    width: 112.66,
    height: 89.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.878333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.6700000000001,
    y: 86.54499999999999
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.76,
    y: 131.17,
    width: 160.12,
    height: 85.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.82,
    y: 173.945
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.76,
    y: 216.73,
    width: 160.12,
    height: 133.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.82,
    y: 283.585
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.76,
    y: 350.44,
    width: 160.12,
    height: 168.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.874285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.82,
    y: 434.895
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.76,
    y: 519.35,
    width: 160.12,
    height: 180.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.556363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.82,
    y: 609.6750000000001
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.88,
    y: 131.17,
    width: 142.68,
    height: 224.77,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.22,
    y: 243.555
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.57,
    y: 131.17,
    width: 145.49,
    height: 224.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.315,
    y: 243.555
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.05,
    y: 131.17,
    width: 169.95,
    height: 224.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.025,
    y: 243.555
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.88,
    y: 355.95,
    width: 295.59,
    height: 157.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.18166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.67499999999995,
    y: 434.495
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.88,
    y: 513.03,
    width: 295.59,
    height: 186.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.161666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.67499999999995,
    y: 606.515
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.47,
    y: 355.95,
    width: 162.53,
    height: 344.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.506
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.735,
    y: 527.975
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.1277e02eb52176be15e387a5a5dfc5c0.svg";
export { ForwardRef as ReactComponent };